/**
 * @generated SignedSource<<739dfc853bfad69d6e306d8e6203605d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraBoardType = "KANBAN" | "SCRUM" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type HorizontalNavBoardHeader_board$data = {
  readonly __typename: "JiraBoard";
  readonly __id: string;
  readonly boardId: AGG$Long;
  readonly boardType: JiraBoardType;
  readonly canEdit: boolean | null | undefined;
  readonly favouriteValue: {
    readonly isFavourite: boolean;
  } | null | undefined;
  readonly name: string;
  readonly " $fragmentType": "HorizontalNavBoardHeader_board";
};
export type HorizontalNavBoardHeader_board$key = {
  readonly " $data"?: HorizontalNavBoardHeader_board$data;
  readonly " $fragmentSpreads": FragmentRefs<"HorizontalNavBoardHeader_board">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "HorizontalNavBoardHeader_board",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "boardId"
      },
      "action": "THROW",
      "path": "boardId"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW",
      "path": "name"
    },
    {
      "kind": "ScalarField",
      "name": "canEdit"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "boardType"
      },
      "action": "THROW",
      "path": "boardType"
    },
    {
      "concreteType": "JiraFavouriteValue",
      "kind": "LinkedField",
      "name": "favouriteValue",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "isFavourite"
          },
          "action": "THROW",
          "path": "favouriteValue.isFavourite"
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "__id"
          },
          "action": "THROW",
          "path": "__id"
        }
      ]
    }
  ],
  "type": "JiraBoard"
};

(node as any).hash = "2bee90c92c0551f1635f4463f247385b";

export default node;
